// Central error sink. Today it logs in a structured way; wire this to an
// error-tracking service (Sentry/Datadog/etc.) in one place later.

interface ReportedError {
  source: string
  error: unknown
  info?: unknown
}

export const reportError = ({ source, error, info }: ReportedError): void => {
  // eslint-disable-next-line no-console
  console.error(`[error:${source}]`, error, info ?? '')
  // TODO: forward to an error-tracking service here.
}

let registered = false

/**
 * Registers global handlers so async failures are no longer silently lost.
 * Safe to call multiple times — it only registers once.
 */
export const registerGlobalErrorHandlers = (): void => {
  if (registered || typeof window === 'undefined') {
    return
  }
  registered = true

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    reportError({ source: 'unhandledrejection', error: event.reason })
  })

  window.addEventListener('error', (event: ErrorEvent) => {
    reportError({ source: 'window.onerror', error: event.error ?? event.message })
  })
}
